import React from 'react'
import { Card_1 } from '../../../component/landingComponent'

const Section_2 = () => {
    const cardOnClickHandler = (type) =>{
        window.location.hash = type;
    }
    return (
        <>
            <div className="container">
                <div className="process-wrapper">
                    <div className="row gaap-20">
                        <div className="col-md-4">

                            <Card_1
                                icon='/media/saiMedia/no-code.png'
                                title='Truvoice AI Platform'
                                subTitle="Build powerful Virtual Agents with ease — no coding needed."
                                isClick={true}
                                cardOnClick={() => cardOnClickHandler('platform')}
                            />
                        </div>
                        <div className="col-md-4">
                            <Card_1
                                icon='/media/saiMedia/fully-managed.png'
                                title='Fully Managed AI Agents'
                                subTitle="Developed, deployed and maintained.  No infrastructure or resources from you."
                                isClick={true}
                                cardOnClick={() => cardOnClickHandler('fully-managed')}
                            />
                        </div>
                        <div className="col-md-4">
                            <Card_1
                                icon='/media/saiMedia/custom-agent.png'
                                title='Custom Virtual Agents'
                                subTitle="Custom-built per your specifications — deploy anywhere."
                                isClick={true}
                                cardOnClick={() => cardOnClickHandler('virtual-agents')}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export {Section_2}